export default "__VITE_PUBLIC_ASSET__5c581048__"